var module = angular.module('octopusApp.library');

module.controller('LibraryLayoutController', function($scope, $state, octopusPermissionSet) {

    // We want the default sub-route to be the first of these the user has permissions for.
    // If we require similar functionality on other views, it would be nice build support for this
    // in our state configuration.  e.g. allow a function to be supplied as the defaultSubRoute.

    // This logic only applies if we are loading the default sub-route
    if ($state.current.name !== 'app.library') {
        return;
    }

    var tabs = [
        { state: 'app.library.packages', permission: 'FeedView', wildcard: true},
        { state: 'app.library.lifecycles', permission: 'LifeCycleEdit', wildcard: true},
        { state: 'app.library.scripts', permission: 'VariableView', wildcard: false},
        { state: 'app.library.steptemplates', permission: 'ActionTemplateView', wildcard: false},
        { state: 'app.library.variables', permission: 'VariableView', wildcard: true},
        { state: 'app.library.certificates', permission: 'CertificateView', wildcard: true}
    ];

    var i = 0;

    evaluateNextState();

    function evaluateNextState() {
        checkPermission(tabs[i].permission, tabs[i].wildcard)
            .then(function (isAuthorized) {
                if (isAuthorized) {
                    $state.go(tabs[i].state);
                } else {
                    i++;
                    evaluateNextState();
                }
            });
    }

    function checkPermission(permission, wildcard) {
        var authorization = { permission: permission};

        if (wildcard) {
           _.extend(authorization, {environmentId: '*', projectId: '*', projectGroupId: '*'});
        }
       return octopusPermissionSet.isAuthorized(authorization);
    }

});



//////////////////
// WEBPACK FOOTER
// ./app/areas/library/layout/library_layout_controller.js
// module id = 4601048933505747
// module chunks = 1